<div class="text-center">
  <div>
    <img
      src="assets/images/steps_{{ getStopovers() }}.png"
      alt="{{ getStopovers() }} steps">

    <em class="fa fa-plane itinerary-flight ml-2"></em>
  </div>

  <div *ngIf="isDirect(); then directFlight; else flightWithStopovers"></div>
  <ng-template #directFlight>
    <h6>{{ "ITINERARY.TRANSPORT.FLIGHT.DIRECT-FLIGHT" | translate }}</h6>
  </ng-template>

  <ng-template #flightWithStopovers>
    <h6>
      {{ getStopovers() }}
      {{ "ITINERARY.TRANSPORT.FLIGHT.STOPOVER" | translate }}:
      {{ getIATAScali() }}
    </h6>
  </ng-template>
</div>
